import { create } from "zustand";
import { devtools } from "zustand/middleware";

const VIEW_KEY = "view-mode";

export type ViewState = {
  isAdminView: boolean;
  onInit(): void;
  toggleView(): void;
};

export const ViewStore = create<ViewState>()(
  devtools((set, getState) => ({
    isAdminView: true,

    onInit: () => {
      const stored = localStorage.getItem(VIEW_KEY);
      set({ isAdminView: stored !== "pro" });
    },

    toggleView: () => {
      const next = !getState().isAdminView;
      set({ isAdminView: next });
      localStorage.setItem(VIEW_KEY, next ? "admin" : "pro");
    },
  })),
);
